export const filterDefined = <T extends object>(obj: T): T =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value !== 'undefined') {
      acc[key] = value;
    }

    return acc;
  }, {} as T);
